<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import GgContactInfo from 'dashboard/routes/dashboard/conversation/contact/GgContactInfo.vue';

const props = defineProps({
  selectedContact: { type: Object, required: true },
});
defineOptions({ name: 'GgCompanyCard' });
const { t } = useI18n();
const contact = computed(() => ({
  custom_attributes: props.selectedContact.customAttributes,
}));
</script>

<template>
  <section
    class="rounded-xl border border-n-weak bg-n-solid-1 p-4"
    :aria-label="t('GG_CONTACT.COMPANY_PANEL')"
  >
    <div class="mb-4 flex items-center gap-2">
      <span class="i-lucide-building-2 size-5 shrink-0 text-n-brand" />
      <h3 class="m-0 text-base font-medium text-n-slate-12">
        {{ t('GG_CONTACT.COMPANY_PANEL') }}
      </h3>
    </div>
    <p class="mb-4 text-xs text-n-slate-11">
      {{ t('GG_CONTACT.COMPANY_PANEL_HINT') }}
    </p>
    <GgContactInfo
      :key="selectedContact.id"
      :contact="contact"
      :contact-id="selectedContact.id"
      detailed
    />
  </section>
</template>
